document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-bv-buy-now]');
  if (!button || button.disabled) return;

  const form = button.closest('form');
  const addButton = form?.querySelector('[name="add"]');
  const variant = form?.querySelector('[name="id"]');
  if (!form || !variant?.value || addButton?.disabled) return;

  button.disabled = true;
  const originalLabel = button.textContent;
  button.textContent = 'Preparando pedido…';

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    if (!response.ok) throw new Error('No se pudo añadir el producto al carrito.');
    window.location.assign(`${root}checkout`);
  } catch (error) {
    button.disabled = false;
    button.textContent = originalLabel;
    const errorBox = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    if (errorBox) {
      errorBox.hidden = false;
      errorBox.querySelector('.product-form__error-message').textContent = error.message;
    }
  }
});
